// extracted by mini-css-extract-plugin
export default {"error_message":"ErrorLoading-module__error_message--mIcIG"};